import React from "react";
import { Link } from "react-router-dom";

import {
  FiBarChart2,
  FiInstagram,
  FiMonitor,
  FiCamera,
  FiTrendingUp,
  FiLayers,
  FiCpu,
  FiShoppingCart,
  FiCreditCard,
  FiUsers,
  FiFileText,
  FiMail,
  FiMapPin,
  FiStar,
  FiSmartphone,
} from "react-icons/fi";

export default function Home({ t, language, mainLogo }) {
  const services = [
    {
      slug: "marketing-team",
      title: language === "en" ? "Marketing Team" : "Equipo de Marketing",
      description:
        language === "en"
          ? "Professional growth strategies and campaign execution."
          : "Estrategias profesionales de crecimiento y ejecución de campañas.",
      icon: <FiTrendingUp />,
    },
    {
      slug: "ai-automation",
      title: language === "en" ? "AI Automation" : "Automatización IA",
      description:
        language === "en"
          ? "AI workflows, automations, and business optimization."
          : "Flujos de IA, automatizaciones y optimización del negocio.",
      icon: <FiCpu />,
    },
    {
      slug: "websites",
      title: language === "en" ? "Websites" : "Sitios Web",
      description:
        language === "en"
          ? "Luxury modern websites built for conversions."
          : "Sitios web modernos y premium diseñados para convertir.",
      icon: <FiMonitor />,
    },
    {
      slug: "ecommerce",
      title: "Ecommerce",
      description:
        language === "en"
          ? "Online stores and integrated sales systems."
          : "Tiendas online y sistemas de ventas integrados.",
      icon: <FiShoppingCart />,
    },
    {
      slug: "payments",
      title: language === "en" ? "Payments" : "Pagos",
      description:
        language === "en"
          ? "Seamless online payment processing."
          : "Procesamiento de pagos online simple y seguro.",
      icon: <FiCreditCard />,
    },
    {
      slug: "crm",
      title: "CRM",
      description:
        language === "en"
          ? "Customer relationship management systems."
          : "Sistemas para gestionar clientes, ventas y oportunidades.",
      icon: <FiUsers />,
    },
    {
      slug: "forms-leads",
      title: language === "en" ? "Forms Lead" : "Formularios y Leads",
      description:
        language === "en"
          ? "Lead generation and client intake forms."
          : "Formularios para captar leads y recibir nuevos clientes.",
      icon: <FiFileText />,
    },
    {
      slug: "email-marketing",
      title: "Email Marketing",
      description:
        language === "en"
          ? "Automated email campaigns and funnels."
          : "Campañas automatizadas de email y embudos de venta.",
      icon: <FiMail />,
    },
    {
      slug: "listings",
      title: "Listings",
      description:
        language === "en"
          ? "Google, Facebook & business directory optimization."
          : "Optimización en Google, Facebook y directorios comerciales.",
      icon: <FiMapPin />,
    },
    {
      slug: "reputation-review",
      title: language === "en" ? "Reputation Review" : "Reputación y Reseñas",
      description:
        language === "en"
          ? "Review management and reputation growth."
          : "Gestión de reseñas y crecimiento de reputación online.",
      icon: <FiStar />,
    },
    {
      slug: "social",
      title: "Social",
      description:
        language === "en"
          ? "Social media management and scaling."
          : "Gestión y crecimiento de redes sociales.",
      icon: <FiInstagram />,
    },
    {
      slug: "content",
      title: language === "en" ? "Content" : "Contenido",
      description:
        language === "en"
          ? "Professional content creation."
          : "Creación de contenido profesional para tu marca.",
      icon: <FiCamera />,
    },
    {
      slug: "ads",
      title: "Ads",
      description:
        language === "en"
          ? "Paid traffic and multi-channel advertising."
          : "Tráfico pago y publicidad multicanal.",
      icon: <FiBarChart2 />,
    },
    {
      slug: "intelligence",
      title: language === "en" ? "Intelligence" : "Inteligencia",
      description:
        language === "en"
          ? "Advanced reporting and analytics."
          : "Reportes avanzados, métricas y analítica.",
      icon: <FiLayers />,
    },
    {
      slug: "mobile-app",
      title: language === "en" ? "Mobile App" : "App Móvil",
      description:
        language === "en"
          ? "Mobile business management solutions."
          : "Soluciones móviles para gestión empresarial.",
      icon: <FiSmartphone />,
    },
  ];

  return (
    <main className="home">
      <section className="hero">
        <div className="hero-content">
          <span className="eyebrow">{t.heroEyebrow}</span>

          <h1>
            {t.heroTitle1}
            <br />
            <span className="gradient-text">{t.heroTitle2}</span>
            <br />
            {t.heroTitle3}
          </h1>

          <p>{t.heroDescription}</p>

          <div className="hero-actions">
            <a href="#contact" className="btn-primary">
              {t.heroButton1}
            </a>

            <a href="#services" className="btn-secondary">
              {t.heroButton2}
            </a>
          </div>
        </div>

        <div className="hero-card">
          <img src={mainLogo} alt="Matneu" />

          <h3>{t.heroCardTitle}</h3>

          <p>{t.heroCardDescription}</p>

          <div className="stats">
            <div>
              <strong>+360°</strong>
              <span>{t.strategy}</span>
            </div>

            <div>
              <strong>ROI</strong>
              <span>{t.results}</span>
            </div>
          </div>
        </div>
      </section>

      <section id="services" className="section">
        <div className="section-header">
          <h2>{t.servicesTitle}</h2>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <Link
              key={service.slug}
              to={`/services/${service.slug}`}
              className="service-card"
            >
              <div className="service-icon">{service.icon}</div>
              <span>{String(index + 1).padStart(2, "0")}</span>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </Link>
          ))}
        </div>
      </section>

      <section id="about" className="section split">
        <div>
          <span className="eyebrow">{t.growthEyebrow}</span>

          <h2>
            {t.growthTitle1}
            <br />
            <span className="gradient-text">{t.growthTitle2}</span>
          </h2>

          <p>{t.growthDescription}</p>
        </div>

        <div className="features">
          {t.features.map((item) => (
            <div key={item} className="feature">
              <span>✓</span>
              <p>{item}</p>
            </div>
          ))}
        </div>
      </section>

      <section id="contact" className="cta">
        <img src={mainLogo} alt="Logo" />

        <h2>{t.ctaTitle}</h2>

        <p>{t.ctaDescription}</p>

        <a href="https://wa.me/+16893403293" className="btn-primary">
          {t.ctaButton}
        </a>
      </section>
    </main>
  );
}